export const FETCH_LOCATIONS_REQUEST = 'FETCH_LOCATIONS_REQUEST';
export const FETCH_LOCATIONS_SUCCESS = 'FETCH_LOCATIONS_SUCCESS';
export const FETCH_LOCATIONS_FAILED = 'FETCH_LOCATIONS_FAILED';

export const CREATE_LOCATION_REQUEST = 'CREATE_LOCATION_REQUEST';
export const CREATE_LOCATION_SUCCESS = 'CREATE_LOCATION_SUCCESS';
export const CREATE_LOCATION_FAILED = 'CREATE_LOCATION_FAILED';

export const FETCH_LOCATIONS_BY_ID_REQUEST = 'FETCH_LOCATIONS_BY_ID_REQUEST';
export const FETCH_LOCATIONS_BY_ID_SUCCESS = 'FETCH_LOCATIONS_BY_ID_SUCCESS';
export const FETCH_LOCATIONS_BY_ID_FAILED = 'FETCH_LOCATIONS_BY_ID_FAILED';

export const UPDATE_LOCATION_REQUEST = 'UPDATE_LOCATION_REQUEST';
export const UPDATE_LOCATION_SUCCESS = 'UPDATE_LOCATION_SUCCESS';
export const UPDATE_LOCATION_FAILED = 'UPDATE_LOCATION_FAILED';

export const DELETE_LOCATION_REQUEST = 'DELETE_LOCATION_REQUEST';
export const DELETE_LOCATION_SUCCESS = 'DELETE_LOCATION_SUCCESS';
export const DELETE_LOCATION_FAILED = 'DELETE_LOCATION_FAILED';

export const RESET_LOCATION_STATE_REQUEST = 'RESET_LOCATION_STATE_REQUEST';
